import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { browserHistory } from 'react-router';
import Avatar from 'material-ui/Avatar';
import Divider from 'material-ui/Divider';
import { ListItem } from 'material-ui/List';
import { SelectableList } from 'components';
import * as styles from './ContentLeftNav.scss';

var ContentLeftNav = /*#__PURE__*/function (_React$Component) {
  _inherits(ContentLeftNav, _React$Component);

  var _super = _createSuper(ContentLeftNav);

  function ContentLeftNav() {
    _classCallCheck(this, ContentLeftNav);

    return _super.apply(this, arguments);
  }

  _createClass(ContentLeftNav, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.initialScrollPosition) {
        this.wrapDiv.scrollTop = this.props.initialScrollPosition;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          activeCategorySlug = _this$props.activeCategorySlug,
          favorites = _this$props.favorites,
          handleToggleNestedNav = _this$props.handleToggleNestedNav,
          leftNavSectionsOpen = _this$props.leftNavSectionsOpen,
          recommended = _this$props.recommended,
          orgId = _this$props.orgId,
          other = _this$props.other,
          _onScroll = _this$props.onScroll;
      return /*#__PURE__*/React.createElement("div", {
        ref: function ref(r) {
          return _this.wrapDiv = r;
        },
        className: styles.wrap,
        onScroll: function onScroll(_ref) {
          var scrollTop = _ref.target.scrollTop;

          if (_onScroll) {
            _onScroll(scrollTop);
          }
        }
      }, /*#__PURE__*/React.createElement(SelectableList, {
        defaultValue: activeCategorySlug,
        onChange: function onChange() {
          return false;
        },
        style: {
          paddingTop: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.backLinkWrap
      }, /*#__PURE__*/React.createElement(ListItem, {
        primaryText: /*#__PURE__*/React.createElement("span", {
          className: styles.backLink
        }, /*#__PURE__*/React.createElement("i", {
          className: "icon ion-android-arrow-back ".concat(styles.backArrow)
        }), "Content Directory"),
        onClick: function onClick() {
          browserHistory.push("/org/".concat(orgId, "/content/directory"));
        }
      })), /*#__PURE__*/React.createElement(Divider, null), !!favorites.length && /*#__PURE__*/React.createElement(ListItem, {
        primaryText: /*#__PURE__*/React.createElement("span", {
          className: styles.title
        }, "Favorites"),
        open: leftNavSectionsOpen.favorites,
        primaryTogglesNestedList: true,
        nestedListStyle: {
          marginLeft: -18
        },
        onNestedListToggle: function onNestedListToggle() {
          handleToggleNestedNav(orgId, 'favorites', !leftNavSectionsOpen.favorites);
        },
        nestedItems: favorites.map(function (fav, index) {
          return /*#__PURE__*/React.createElement(ListItem, {
            key: "fav_".concat(index, "_").concat(fav.id),
            leftAvatar: /*#__PURE__*/React.createElement(Avatar, {
              src: fav.avatarImageUrl,
              style: {
                objectFit: 'cover'
              }
            }),
            value: fav.slug,
            primaryText: fav.tagName,
            onClick: function onClick() {
              //                this.setState({ listItem: index });
              browserHistory.push({
                pathname: "/org/".concat(orgId, "/content/category/").concat(fav.slug)
              });
            }
          });
        })
      }), !!recommended.length && /*#__PURE__*/React.createElement(ListItem, {
        primaryText: /*#__PURE__*/React.createElement("span", {
          className: styles.title
        }, "Recommended"),
        open: leftNavSectionsOpen.recommended,
        primaryTogglesNestedList: true,
        nestedListStyle: {
          marginLeft: -18
        },
        onNestedListToggle: function onNestedListToggle() {
          handleToggleNestedNav(orgId, 'recommended', !leftNavSectionsOpen.recommended);
        },
        nestedItems: recommended.map(function (rec, index) {
          return /*#__PURE__*/React.createElement(ListItem, {
            key: "rec_".concat(index, "_").concat(rec.id),
            leftAvatar: /*#__PURE__*/React.createElement(Avatar, {
              src: rec.avatarImageUrl,
              style: {
                objectFit: 'cover'
              }
            }),
            value: rec.slug,
            primaryText: rec.tagName,
            onClick: function onClick() {
              //                this.setState({ listItem: index });
              browserHistory.push({
                pathname: "/org/".concat(orgId, "/content/category/").concat(rec.slug)
              });
            }
          });
        })
      }), /*#__PURE__*/React.createElement(ListItem, {
        primaryText: /*#__PURE__*/React.createElement("span", {
          className: styles.title
        }, "All Categories"),
        open: leftNavSectionsOpen.other,
        primaryTogglesNestedList: true,
        nestedListStyle: {
          marginLeft: -18
        },
        onNestedListToggle: function onNestedListToggle() {
          handleToggleNestedNav(orgId, 'other', !leftNavSectionsOpen.other);
        },
        nestedItems: other.map(function (o, index) {
          return /*#__PURE__*/React.createElement(ListItem, {
            key: "other_".concat(index, "_").concat(o.id),
            leftAvatar: /*#__PURE__*/React.createElement(Avatar, {
              src: o.avatarImageUrl,
              style: {
                objectFit: 'cover'
              }
            }),
            value: o.slug,
            primaryText: o.tagName,
            onClick: function onClick() {
              //                this.setState({ listItem: index });
              browserHistory.push({
                pathname: "/org/".concat(orgId, "/content/category/").concat(o.slug)
              });
            }
          });
        })
      })));
    }
  }]);

  return ContentLeftNav;
}(React.Component);

export { ContentLeftNav as default };